import {ValidatorResult} from "../types";
import {BaseValidator} from "./validator.interface";

/**
 * Min value validator for numbers
 */
export class MinValidator extends BaseValidator {
    constructor(
        private readonly min: number,
        message?: string,
    ) {
        super(message || "minValue", {min});
    }

    validate(value: string | number): ValidatorResult {
        const numValue = typeof value === "string" ? parseFloat(value) : value;

        if (isNaN(numValue)) {
            return {isValid: false, error: "mustBeNumber"};
        }

        if (numValue < this.min) {
            return this.fail();
        }

        return this.success();
    }
}

/**
 * Max value validator for numbers
 */
export class MaxValidator extends BaseValidator {
    constructor(
        private readonly max: number,
        message?: string,
    ) {
        super(message || "maxValue", {max});
    }

    validate(value: string | number): ValidatorResult {
        const numValue = typeof value === "string" ? parseFloat(value) : value;

        if (isNaN(numValue)) {
            return {isValid: false, error: "mustBeNumber"};
        }

        if (numValue > this.max) {
            return this.fail();
        }

        return this.success();
    }
}

// TODO: Will be used in future releases
// eslint-disable-next-line @typescript-eslint/no-unused-vars
class RangeValidator extends BaseValidator {
    constructor(
        private readonly min: number,
        private readonly max: number,
        message?: string,
    ) {
        super(message || "valueRange", {min, max});
    }

    validate(value: string | number): ValidatorResult {
        const numValue = typeof value === "string" ? parseFloat(value) : value;

        if (isNaN(numValue)) {
            return {isValid: false, error: "mustBeNumber"};
        }

        if (numValue < this.min || numValue > this.max) {
            return this.fail();
        }

        return this.success();
    }
}

// TODO: Will be used in future releases
// eslint-disable-next-line @typescript-eslint/no-unused-vars
class IntegerValidator extends BaseValidator {
    constructor(message?: string) {
        super(message || "mustBeInteger");
    }

    validate(value: string | number): ValidatorResult {
        const numValue = typeof value === "string" ? parseFloat(value) : value;

        if (isNaN(numValue)) {
            return {isValid: false, error: "mustBeNumber"};
        }

        if (!Number.isInteger(numValue)) {
            return this.fail();
        }

        return this.success();
    }
}

// TODO: Will be used in future releases
// eslint-disable-next-line @typescript-eslint/no-unused-vars
class PositiveValidator extends BaseValidator {
    constructor(message?: string) {
        super(message || "mustBePositive");
    }

    validate(value: string | number): ValidatorResult {
        const numValue = typeof value === "string" ? parseFloat(value) : value;

        if (isNaN(numValue)) {
            return {isValid: false, error: "mustBeNumber"};
        }

        if (numValue <= 0) {
            return this.fail();
        }

        return this.success();
    }
}
